import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=4b2bcda5&scoped=true&"
import script from "./DataExport.vue?vue&type=script&lang=js&"
export * from "./DataExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bcda5",
  null
  
)

export default component.exports